export default "__VITE_ASSET__7d5bb2c2__"